import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=4f6167ec&scoped=true&"
import script from "./exchange.vue?vue&type=script&lang=js&"
export * from "./exchange.vue?vue&type=script&lang=js&"
import style0 from "./exchange.vue?vue&type=style&index=0&id=4f6167ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6167ec",
  null
  
)

export default component.exports